import { Component } from '@angular/core';

@Component({
  selector: 'bu-hero-foot',
  template: `
  <div class="hero-foot">
    <ng-content></ng-content>
  </div>`
})
export class BuHeroFootComponent {}
